import { AxiosBookings, orgId, userId } from "../apiConfig";

import { appendQueryParams } from "../../utilities/urlUtils";

export const billingAndCollectionFactory = {
  $_getAllTransaction(params) {
    const url = `/transactions/user/${userId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
 
  $_getAllTransactionEarning(params) {
    const url = `/billing-collection/partners/all-transaction/${userId()}/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getAllBillings(params) {
    const url = `/billing-collection/transaction/${userId()}/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getAllSettlement(params) {
    const url = `/billing-collection/all-settlement/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getOverview(params) {
    const url = `/billing-collection/overview/org/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  // $_newGetOverview(params) {
  //   const url = `/billing-collection/partners/overview/${userId()}/${orgId()}${appendQueryParams(
  //     params
  //   )}`;
  //   return AxiosBookings.get(url);
  // },
  $_newGetOverview(params) {
    const url = `/earning-payout/overview-partners/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
   $_getIndependentPartnersOverview(params) {
    const url = `/earning-payout/overview-independent-partners/${userId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_sendReciept(transactionId, payload) {
    const url = `/billing-collection/send-receipt/${transactionId}`;
    return AxiosBookings.post(url, payload);
  },
  $_sendInvoice(transactionId, payload) {
    const url = `/billing-collection/send-invoice/${transactionId}`;
    return AxiosBookings.post(url, payload);
  },
  $_getTransaction(params) {
    const url = `/billing-collection/all-transaction/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getReciept(params) {
    const url = `/transactions/${params}`;
    return AxiosBookings.get(url);
  },
   
  $_collectPayment(payload) {
    const url = `/transactions/multiple`;
    return AxiosBookings.post(url, payload);
  },
  $_getBanks(params) {
    const url = `/collection/account/org/${orgId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getAllOverview(params) {
    const url = `/billing-collection/consumer-overview/${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getAccountStatement(params) {
    const url = `/billing-collection/all-settlement/${userId()}${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getShippingHistory(params) {
    const url = `/shippings/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getPaymentLink(shippingId) {
    const url = `/transactions/payment-details/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_newGetPaymentLink(shippingId) {
    const url = `/transactions/get-payment-link/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_sharePayLink(shippingId) {
    const url = `/transactions/share-payment-link/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_getBatchmentSummary(params, payload) {
    const url = `/earning-payout/batchment-summary/${userId()}/${params}${appendQueryParams(payload)}`;
    return AxiosBookings.get(url);
  },
  $_getEarnAndPayout(params) {
    const url = `/earning-payout/earnings-new/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
   $_getCashoutHistory() {
    const url = `/earning-payout/cashout-history/${userId()}`;
    return AxiosBookings.get(url);
  },
   $_getPendingCashout() {
    const url = `/earning-payout/pending-cashout/${userId()}`;
    return AxiosBookings.get(url);
  },
   $_cashOut(payload) {
    const url = `/earning-payout/cashout`;
    return AxiosBookings.post(url, payload);
  },
   $_getEarnAndPayoutDateDropdown(params) {
    const url = `/earning-payout/date-filter/${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
   $_getEarningsAndPayouts(params) {
    const url = `/earning-payout/overview-new/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
   $_getTeirCategory(params) {
    const url = `/earning-payout/current-tier-new/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getViewCurrentTeir(params) {
    const url = `/earning-payout/current-teir/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getViewPriceTier(type) {
    const url = `/earning-payout/price-teir-info/${type}`;
    return AxiosBookings.get(url);
  },
  $_getViewPriceHistory(params) {
    const url = `/earning-payout/teir-history/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
};
